(function ($) {
  class Business {
    constructor(root) {
      this.root = root;
  
      this.historySwiperEl = this.root.querySelector(
        ".js-business-system-swiper",
      );
  
      this.init();
      this.mount();
    }
    init() {
      this.historySwiperEl && this.historySwiper();
    }
    mount() {}
    historySwiper() {
      const prevEl = this.root.querySelector(".js-business-system-swiper__prev");
      const nextEl = this.root.querySelector(".js-business-system-swiper__next");
      const paginationEl = this.root.querySelector(
        ".js-business-system-swiper__pagination",
      );
      new Swiper(this.historySwiperEl, {
        loop: false,
        slidesPerView: "auto",
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        pagination: {
          el: paginationEl,
          type: "bullets",
        },
      });
    }
  }
  
    class Company {
    constructor(root) {
      this.root = root;
  
      this.historySwiperEl = this.root.querySelector(".js-history-swiper");
  
      this.init();
      this.mount();
    }
    init() {
      this.historySwiperEl && this.historySwiper();
    }
    mount() {}
    historySwiper() {
      const prevEl = this.root.querySelector(".js-history-swiper__prev");
      const nextEl = this.root.querySelector(".js-history-swiper__next");
      new Swiper(this.historySwiperEl, {
        loop: false,
        slidesPerView: "auto",
        slidesPerGroup: 3,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
      });
    }
  }
  
    class Internship {
    constructor(root) {
      this.root = root;
  
      this.voiceSwiperEl = this.root.querySelector(".js-voice-swiper");
  
      this.init();
      this.mount();
    }
    init() {
      this.voiceSwiperEl && this.voiceSwiper();
    }
    mount() {}
    voiceSwiper() {
      const prevEl = this.root.querySelector(".js-voice-swiper__prev");
      const nextEl = this.root.querySelector(".js-voice-swiper__next");
      new Swiper(this.voiceSwiperEl, {
        loop: false,
        slidesPerView: "auto",
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
      });
    }
  }
  
    class Top {
    constructor(root) {
      this.root = root;
      // mvスライダ-
      this.mvSwiperEl = root.querySelector(".js-mv-swiper");
      this.mvSwiper = null;
      // thoughtスライダー（画像のフェードイン）
      this.thoughtSwiperEl = root.querySelector(".js-thought-swiper");
      // works pin
      this.worksPinEl = root.querySelector(".js-works-pin");
      this.worksPinTriggers = [];
  
      this.mvSwiperDestroy = null;
      this.resizeHandler = null;
  
      this.init();
      this.mount();
    }
    init() {
      // TODO 260424 一時非表示
      // if (this.mvSwiperEl) {
      //   this.mvSwiperInit();
      // }
  
      if (this.worksPinEl && !isMobile()) {
        this.worksPinInit();
      }
  
      this.thoughtSwiperEl && this.thoughtSwiperInit();
  
      this.resizeBind();
    }
  
    mount() {}
    thoughtSwiperInit() {
      new Swiper(this.thoughtSwiperEl, {
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 3000,
        },
        speed: 2000,
        allowTouchMove: false,
      });
    }
    debounce(func, wait = 300) {
      let timer = null;
  
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    }
    mvSwiperInit() {
      if (this.mvSwiperEl.dataset.swiperInit === "1") return;
      this.mvSwiperEl.dataset.swiperInit = "1";
  
      const SLIDE_STAY = 8;
      const tls = [];
      let currentTL = null;
  
      const setSlide = (slideEl) => {
        if (!slideEl) return;
  
        gsap.set(slideEl.querySelectorAll(".js-mv-swiper__text .in-picture"), {
          opacity: 0,
          y: 100,
          x: -50,
        });
  
        gsap.set(slideEl.querySelector(".js-mv-swiper__people"), {
          opacity: 0,
          y: 100,
          x: -100,
        });
      };
  
      const buildStartTL = (slideEl) => {
        const tl = gsap.timeline();
  
        tl.to(slideEl.querySelector(".js-mv-swiper__people"), {
          opacity: 1,
          y: 0,
          x: 0,
          duration: 0.3,
        }).to(
          slideEl.querySelectorAll(".js-mv-swiper__text .in-picture"),
          {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 0.3,
            stagger: 0.1,
          },
          "<=0.1",
        );
  
        return tl;
      };
  
      const buildEndTL = (slideEl) => {
        const tl = gsap.timeline();
  
        tl.to(slideEl.querySelector(".js-mv-swiper__people"), {
          opacity: 0,
          duration: 0.3,
        }).to(
          slideEl.querySelectorAll(".js-mv-swiper__text .in-picture"),
          {
            opacity: 0,
            y: -30,
            x: 30,
            duration: 0.2,
            stagger: 0.05,
          },
          "=",
        );
  
        return tl;
      };
  
      const getOrCreateTL = (slideEl, swiper) => {
        let tl = slideEl._mvTL;
        if (tl) return tl;
  
        setSlide(slideEl);
  
        tl = gsap.timeline({ paused: true });
  
        tl.add(buildStartTL(slideEl), "start")
          .to({}, { duration: SLIDE_STAY }, "hold")
          .add(buildEndTL(slideEl), "end")
          .call(() => {
            swiper.slideNext();
          });
  
        slideEl._mvTL = tl;
        tls.push(tl);
  
        return tl;
      };
  
      const playActive = (swiper) => {
        const slideEl = swiper.slides[swiper.activeIndex];
        const nextIndex = (swiper.activeIndex + 1) % swiper.slides.length;
        const nextSlideEl = swiper.slides[nextIndex];
  
        setSlide(nextSlideEl);
  
        if (currentTL) {
          currentTL.pause(0);
        }
  
        const tl = getOrCreateTL(slideEl, swiper);
        currentTL = tl;
  
        setSlide(slideEl);
        tl.restart(true);
      };
  
      this.mvSwiper = new Swiper(this.mvSwiperEl, {
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 10,
        allowTouchMove: false,
        on: {
          init() {
            playActive(this);
          },
          slideChangeTransitionEnd() {
            playActive(this);
          },
        },
      });
  
      this.mvSwiperDestroy = () => {
        tls.forEach((tl) => tl.kill());
        currentTL = null;
  
        if (this.mvSwiper) {
          this.mvSwiper.destroy(true, true);
          this.mvSwiper = null;
        }
  
        this.mvSwiperEl.dataset.swiperInit = "0";
  
        this.mvSwiperEl.querySelectorAll(".swiper-slide").forEach((slideEl) => {
          delete slideEl._mvTL;
        });
  
        this.mvSwiperEl
          .querySelectorAll(
            ".js-mv-swiper__text .in-picture, .js-mv-swiper__people",
          )
          .forEach((el) => {
            gsap.killTweensOf(el);
            gsap.set(el, { clearProps: "all" });
          });
      };
    }
    worksPinInit() {
      this.worksPinDestroy();
  
      const works = this.root.querySelectorAll(".js-work");
      if (!works.length) return;
  
      const setCurrent = (activeIndex) => {
        works.forEach((work, index) => {
          work.classList.toggle("is-current", index === activeIndex);
        });
      };
  
      works.forEach((_, index) => {
        if (index === 0) return;
  
        const trigger = ScrollTrigger.create({
          trigger: this.worksPinEl,
          start: () => {
            const prevRatio = (index / works.length) * 100;
            return `${prevRatio}% center`;
          },
          end: () => {
            const currentRatio = ((index + 1) / works.length) * 100;
            return `${currentRatio}% center`;
          },
          invalidateOnRefresh: true,
          onEnter: () => setCurrent(index),
          onEnterBack: () => setCurrent(index),
          onLeaveBack: () => setCurrent(index - 1),
        });
  
        this.worksPinTriggers.push(trigger);
      });
  
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
        ScrollTrigger.update();
  
        const activeTriggerIndex = this.worksPinTriggers.findIndex(
          (trigger) => trigger.isActive,
        );
  
        if (activeTriggerIndex === -1) {
          setCurrent(0);
        } else {
          setCurrent(activeTriggerIndex + 1);
        }
      });
    }
    worksPinDestroy() {
      if (this.worksPinTriggers.length) {
        this.worksPinTriggers.forEach((trigger) => trigger.kill());
        this.worksPinTriggers = [];
      }
  
      this.root.querySelectorAll(".js-work").forEach((work) => {
        work.classList.remove("is-current");
      });
    }
    resizeBind() {
      if (this.resizeHandler) return;
  
      let lastWidth = window.innerWidth;
  
      this.resizeHandler = this.debounce(() => {
        if (lastWidth === window.innerWidth) return;
        lastWidth = window.innerWidth;
  
        const shouldResetWorksPinScroll = this.isInWorksPinSection();
  
        if (this.mvSwiperDestroy) {
          this.mvSwiperDestroy();
          this.mvSwiperInit();
        }
  
        this.worksPinDestroy();
  
        const rebuildWorksPin = () => {
          if (this.worksPinEl && !isMobile()) {
            this.worksPinInit();
          }
  
          requestAnimationFrame(() => {
            ScrollTrigger.refresh();
            ScrollTrigger.update();
          });
        };
  
        if (shouldResetWorksPinScroll && this.worksPinEl) {
          const top =
            window.scrollY + this.worksPinEl.getBoundingClientRect().top;
  
          window.scrollTo(0, top);
  
          requestAnimationFrame(() => {
            rebuildWorksPin();
          });
          return;
        }
  
        rebuildWorksPin();
      }, 300);
  
      window.addEventListener("resize", this.resizeHandler);
    }
    isInWorksPinSection() {
      if (!this.worksPinEl) return false;
  
      const rect = this.worksPinEl.getBoundingClientRect();
      const scrollTop = window.scrollY;
      const sectionTop = scrollTop + rect.top;
      const sectionBottom = sectionTop + this.worksPinEl.offsetHeight;
      const currentScroll = scrollTop;
      const viewportCenter = currentScroll + window.innerHeight / 2;
  
      return viewportCenter >= sectionTop && viewportCenter <= sectionBottom;
    }
  }
  
    class Training {
    constructor(root) {
      this.root = root;
  
      this.trainingSwiperEl = this.root.querySelector(
        ".js-training-story-swiper",
      );
  
      this.init();
      this.mount();
    }
    init() {
      this.storyModalSwiperEl && this.storyModalSwiper();
      this.trainingSwiperEl && this.trainingSwiper();
    }
    mount() {}
    trainingSwiper() {
      const progressBarEl = document.querySelector(
        ".js-training-story-swiper__progressbar",
      );
      new Swiper(this.trainingSwiperEl, {
        slidesPerView: 1.1,
        spaceBetween: 12,
        pagination: {
          el: progressBarEl,
          type: "progressbar",
        },
      });
    }
  }
  
  const breadcrumbScrollToggle = () => {
    const MOBILE_MEDIA = "(max-width: 768px)";
    const breadcrumbs = document.querySelectorAll(".js-scroll-breadcrumb");
    if (!breadcrumbs.length) return;
  
    const update = () => {
      const isMobile = window.matchMedia(MOBILE_MEDIA).matches;
  
      breadcrumbs.forEach((breadcrumb) => {
        const items = breadcrumb.querySelectorAll(".c-breadcrumb__item");
        if (!items.length) {
          breadcrumb.classList.remove("is-scroll");
          return;
        }
  
        if (!isMobile) {
          breadcrumb.classList.remove("is-scroll");
          return;
        }
  
        const totalWidth = Array.from(items).reduce((sum, item) => {
          const style = window.getComputedStyle(item);
          const marginLeft = parseFloat(style.marginLeft) || 0;
          const marginRight = parseFloat(style.marginRight) || 0;
          return (
            sum + item.getBoundingClientRect().width + marginLeft + marginRight
          );
        }, 0);
  
        const breadcrumbWidth = breadcrumb.clientWidth;
  
        breadcrumb.classList.toggle("is-scroll", totalWidth > breadcrumbWidth);
      });
    };
  
    update();
  };
  
    const clearFormButton = (button) => {
    button.addEventListener("click", () => {
      const form = button.closest("form");
      if (!form) return;
  
      form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });
    });
  };
  
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class CountUpNumber {
    constructor(el) {
      const countUpEls = document.querySelectorAll(el);
      if (countUpEls.length > 0) {
        this.event(countUpEls);
      }
    }
  
    event(countUpEls) {
      countUpEls.forEach((item) => {
        const resultNumber = Number(item.dataset.result || 0);
        const durationTime = Number(item.dataset.duration || 800);
        const useComma = item.dataset.comma !== "false";
  
        gsap.to(item, {
          scrollTrigger: {
            trigger: item,
            start: "top 75%",
            end: "top center",
            once: true,
            onEnter: () => {
              this.countUp(resultNumber, item, durationTime, useComma);
            },
          },
        });
      });
    }
  
    formatNumber(number, useComma = true) {
      return useComma ? number.toLocaleString() : String(number);
    }
  
    countUp(resultNumber, resultElement, duration = 500, useComma = true) {
      if (!resultElement) return;
  
      let currentNumber = 0;
      const interval = 10;
      const step = resultNumber / (duration / interval);
  
      const counter = setInterval(() => {
        currentNumber += step;
  
        if (currentNumber >= resultNumber) {
          currentNumber = resultNumber;
          clearInterval(counter);
        }
  
        const displayNumber = Math.floor(currentNumber);
        resultElement.textContent = this.formatNumber(displayNumber, useComma);
      }, interval);
    }
  }
  
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    const headerInfoSwiper = (root = document) => {
    const swiperEl = root.querySelector(".js-header-info-swiper");
    if (!swiperEl) return;
  
    // 二重初期化防止
    if (swiperEl.classList.contains("swiper-initialized")) return;
  
    new Swiper(swiperEl, {
      loop: true,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false, // 任意（途切れない運用なら推奨）
      },
      speed: 7000,
      slidesPerView: isMobile() ? "auto" : 1,
      spaceBetween: isMobile() && 100,
    });
  };
  
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InterviewSwiper {
    constructor() {
      // interview 1枚表示のスライダー
      this.currentInterivewSwiperEl = document.querySelector(
        ".js-interview-current-swiper",
      );
      // interview
      this.interivewSwiperEl = document.querySelector(".js-interview-swiper");
  
      this.init();
    }
    init() {
      this.currentInterivewSwiperEl && this.currentInterivewSwiperInit();
      this.interivewSwiperEl && this.interivewSwiperInit();
    }
    currentInterivewSwiperInit() {
      const prev = document.querySelector(".js-interview-current-swiper__prev");
      const next = document.querySelector(".js-interview-current-swiper__next");
      const fraction = document.querySelector(
        ".js-interview-current-swiper__fraction",
      );
      this.currentInterviewSwiper = new Swiper(this.currentInterivewSwiperEl, {
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        pagination: {
          el: fraction,
          type: "fraction",
          renderFraction: function (currentClass, totalClass) {
            return `
              <span class="${currentClass}"></span>
              <span class="swiper-pagination-separator">|</span>
              <span class="${totalClass}"></span>
            `;
          },
        },
        allowTouchMove: isMobile() ? true : false,
      });
    }
    interivewSwiperInit() {
      const prev = document.querySelector(".js-interview-current-swiper__prev");
      const next = document.querySelector(".js-interview-current-swiper__next");
      this.interviewSwiper = new Swiper(this.interivewSwiperEl, {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 20,
        allowTouchMove: false,
        initialSlide: 1,
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
      });
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      $('.js-load-inview').animate({'opacity': '1'});
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    const isMobile = () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    return isMobile;
  };
  
    const loading = (el) => {
    if (!el) return;
    if (el.dataset.loaded === "true") return;
  
    el.dataset.loaded = "true";
  
    gsap.to(el, {
      height: 0,
      duration: 0.3,
      delay: 0.5,
      onComplete() {
        el.remove();
      },
    });
  
    const logo = document.querySelector(".js-loading__logo");
    if (logo) {
      gsap.to(logo, {
        opacity: 0,
        duration: 0.3,
      });
    }
  };
  
    const marquee = (els, innerSelector, childSelector, options = {}) => {
    const { pxPerSec = 80, tripleAfterFill = true } = options;
  
    const waitImages = (root) => {
      const imgs = Array.from(root.querySelectorAll("img"));
      if (!imgs.length) return Promise.resolve();
  
      return Promise.all(
        imgs.map((img) => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
  
          if (img.decode) {
            return img.decode().catch(() => {
              return new Promise((resolve) => {
                img.addEventListener("load", resolve, { once: true });
                img.addEventListener("error", resolve, { once: true });
              });
            });
          }
  
          return new Promise((resolve) => {
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          });
        }),
      );
    };
  
    els.forEach((el) => {
      const inner = el.querySelector(innerSelector);
      if (!inner) return;
  
      if (el.dataset.marqueeInit === "1") return;
      el.dataset.marqueeInit = "1";
  
      waitImages(el).then(() => {
        const isVertical = el.dataset.marquee === "vertical";
        const getItems = () => Array.from(inner.querySelectorAll(childSelector));
  
        const measureSetSize = () => {
          const items = getItems();
          let total = 0;
  
          items.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const style = getComputedStyle(item);
  
            if (isVertical) {
              const marginT = parseFloat(style.marginTop) || 0;
              const marginB = parseFloat(style.marginBottom) || 0;
              total += rect.height + marginT + marginB;
            } else {
              const marginL = parseFloat(style.marginLeft) || 0;
              const marginR = parseFloat(style.marginRight) || 0;
              total += rect.width + marginL + marginR;
            }
          });
  
          return total;
        };
  
        const baseItems = getItems();
        if (!baseItems.length) return;
  
        let baseSize = measureSetSize();
        if (!baseSize) return;
  
        const containerSize = isVertical
          ? el.getBoundingClientRect().height
          : el.getBoundingClientRect().width;
  
        const appendBaseSet = () => {
          const frag = document.createDocumentFragment();
          baseItems.forEach((node) => frag.appendChild(node.cloneNode(true)));
          inner.appendChild(frag);
        };
  
        while (baseSize < containerSize) {
          appendBaseSet();
          baseSize = measureSetSize();
        }
  
        const filledSetSize = measureSetSize();
        if (!filledSetSize) return;
  
        if (tripleAfterFill) {
          const filledNodes = Array.from(inner.children);
          const cloneChildren = () => {
            const frag = document.createDocumentFragment();
            filledNodes.forEach((n) => frag.appendChild(n.cloneNode(true)));
            inner.appendChild(frag);
          };
          cloneChildren();
          cloneChildren();
        }
  
        const distance = filledSetSize;
        const durationSec = distance / (el.dataset.persec ?? pxPerSec);
  
        inner.style.setProperty("--marquee-distance", `${distance}px`);
        inner.style.setProperty("--marquee-duration", `${durationSec}s`);
      });
    });
  };
  
    const memberSwiper = (els) => {
    els.forEach((item) => {
      const progressbarEl = item.querySelector(".js-member-swiper__progressbar");
      new Swiper(item, {
        spaceBetween: 10,
        pagination: {
          el: progressbarEl,
          type: "progressbar",
        },
      });
    });
  };
  
    const mobileNav = (el) => {
    if (!el) return;
    gsap.to(el, {
      opacity: 0,
      pointerEvent: "none",
      scrollTrigger: {
        trigger: ".js-footer",
        start: "top bottom",
        end: "10% bottom",
        toggleActions: "play none reverse none",
      },
    });
  };
  
    function moveToHashAfterLoading() {
    const hash = window.location.hash;
  
    if (!hash) return;
  
    const target = document.querySelector(hash);
    if (!target) return;
  
    // 初期表示時の自動スクロールを止める
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  
    // ブラウザの自動ジャンプを打ち消す
    window.scrollTo(0, 0);
  
    const scrollToTarget = () => {
      const targetTop =
        target.getBoundingClientRect().top + window.pageYOffset - 50;
  
      window.scrollTo({
        top: targetTop,
        left: 0,
        behavior: "smooth",
      });
    };
  
    // ローディング完了後に移動
    $(window).one("loading", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToTarget();
        });
      });
    });
  }
  
    const remToPx = (rem) => {
    const rootFontSize = parseFloat(
      getComputedStyle(document.documentElement).fontSize,
    );
    return rem * rootFontSize;
  };
  
    // -------------------------------------------------
  // スクロール禁止
  // -------------------------------------------------
  let scrollTop = 0;
  
  function scrollBan() {
    const body = $('html')[0];
    if (body.classList.contains('is-hidden')) {
      // スクロール開放
      body.style.top = '';
      body.classList.remove('is-hidden');
      window.scrollTo(0, scrollTop);
    } else {
      // スクロール禁止
      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('is-hidden');
    }
  }
    const scrollHint = () => {
    new ScrollHint(".js-scroll-hint", {
      i18n: {
        scrollable: "スクロールできます",
      },
    });
  };
  
    function slideList(els) {
    els.forEach((el) => {
      const swiperEl = el.querySelector(".js-list-swiper");
      const prevEl = el.querySelector(".js-list-swiper__prev");
      const nextEl = el.querySelector(".js-list-swiper__next");
      const buttonWrapperEl = el.querySelector(".c-slide-list__button-wrapper");
  
      const swiper = new Swiper(swiperEl, {
        loop: false,
        slidesPerView: "auto",
        slidesPerGroup: 1,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        on: {
          resize(swiperInstance) {
            if (!buttonWrapperEl) return;
            buttonWrapperEl.classList.toggle("is-hidden", swiperInstance.isLocked);
          },
        },
        breakpoints: {
          768: {
            slidesPerGroup: 2,
          },
        },
      });
  
      if (buttonWrapperEl) {
        buttonWrapperEl.classList.toggle("is-hidden", swiper.isLocked);
      }
    });
  }
  
    function createToc(options = {}) {
    const {
      tocSelector = ".js-toc",
      contentSelector = ".js-toc-content",
      headingSelector = ".js-toc-heading",
      textSelector = ".js-toc-text",
      idPrefix = "toc",
      clearToc = true,
      itemClass = "c-toc__item",
      currentClass = "is-current",
      setFirstCurrent = true,
  
      observeScroll = true,
      rootMarginTop = -80,
      rootMarginBottom = -60,
      threshold = [0, 1],
  
      currentTextSelector = ".js-toc-current",
      mobileMedia = "(max-width: 767px)",
      currentTextJoiner = "",
  
      headingLabelSelector = ".js-toc-heading-label",
      prependHeadingOnMobile = true,
      headingItemClass = "c-toc__item c-toc__item--heading",
  
      mobileWrapperSelector = ".c-toc__mobile-wrapper",
      mobileListWrapperSelector = ".c-toc__list-wrapper",
      mobileToggleStateKey = "toggle",
      mobileScrollOffset = 80,
      collapseFallbackDelay = 10,
    } = options;
  
    const toc = document.querySelector(tocSelector);
    const content = document.querySelector(contentSelector);
    if (!toc || !content) return null;
  
    const tocRoot = toc.closest(".c-toc") || toc.parentElement;
  
    const headings = Array.from(content.querySelectorAll(headingSelector));
    if (!headings.length) return { toc, headings, destroy: () => {} };
  
    if (clearToc) toc.innerHTML = "";
  
    const usedIds = new Set(
      Array.from(document.querySelectorAll("[id]"))
        .map((el) => el.id)
        .filter(Boolean),
    );
  
    const ensureId = (el, index) => {
      if (el.id && !usedIds.has(el.id)) {
        usedIds.add(el.id);
        return el.id;
      }
      if (el.id && usedIds.has(el.id)) el.id = "";
  
      let id = `${idPrefix}${index + 1}`;
      let n = 2;
      while (usedIds.has(id)) id = `${idPrefix}${index + 1}-${n++}`;
      el.id = id;
      usedIds.add(id);
      return id;
    };
  
    const getHeadingLabel = (heading) => {
      const dataToc = heading.getAttribute("data-toc");
      if (dataToc && dataToc.trim()) {
        return dataToc.replace(/\s+/g, " ").trim();
      }
  
      const textEl = heading.querySelector(textSelector);
      const raw = textEl ? textEl.textContent : heading.textContent;
      return String(raw || "")
        .replace(/\s+/g, " ")
        .trim();
    };
  
    const idToLi = new Map();
    const idToLabel = new Map();
    let firstId = null;
  
    headings.forEach((heading, i) => {
      const label = getHeadingLabel(heading);
      if (!label) return;
  
      const id = ensureId(heading, i);
      if (!firstId) firstId = id;
  
      const li = document.createElement("li");
      li.className = itemClass;
  
      const a = document.createElement("a");
      a.href = `#${id}`;
      a.textContent = label;
  
      li.appendChild(a);
      toc.appendChild(li);
  
      idToLi.set(id, li);
      idToLabel.set(id, label);
    });
  
    const currentTextEl =
      tocRoot?.querySelector(currentTextSelector) ||
      document.querySelector(currentTextSelector);
    const mql = window.matchMedia ? window.matchMedia(mobileMedia) : null;
    const mobileHeadingId = "__toc_mobile_heading__";
  
    const getHeadingTopLabel = () => {
      const headingEl =
        tocRoot?.querySelector(headingLabelSelector) ||
        document.querySelector(headingLabelSelector);
  
      if (!headingEl) return "";
      return headingEl.textContent.replace(/\s+/g, " ").trim();
    };
  
    const updateMobileHeadingItem = () => {
      if (!prependHeadingOnMobile || !mql) return;
  
      const existing = toc.querySelector(".js-toc-mobile-heading-item");
      if (existing) existing.remove();
  
      if (!mql.matches) return;
  
      const label = getHeadingTopLabel();
      if (!label) return;
  
      const li = document.createElement("li");
      li.className = `${headingItemClass} js-toc-mobile-heading-item`;
      li.dataset.tocId = mobileHeadingId;
  
      const span = document.createElement("span");
      span.className = "c-toc__text";
      span.textContent = label;
  
      li.appendChild(span);
      toc.prepend(li);
    };
  
    const updateCurrentText = (id) => {
      if (!currentTextEl) return;
      const isMobile = mql ? mql.matches : false;
      if (!isMobile) return;
  
      let label = "";
  
      if (id === mobileHeadingId) {
        label = getHeadingTopLabel();
      } else {
        label = idToLabel.get(id) || "";
      }
  
      currentTextEl.textContent = currentTextJoiner
        ? `${currentTextJoiner}${label}`
        : label;
    };
  
    const setCurrentById = (id) => {
      idToLi.forEach((li) => li.classList.remove(currentClass));
  
      const mobileHeadingItem = toc.querySelector(".js-toc-mobile-heading-item");
      if (mobileHeadingItem) {
        mobileHeadingItem.classList.remove(currentClass);
      }
  
      if (id === mobileHeadingId) {
        if (mobileHeadingItem) mobileHeadingItem.classList.add(currentClass);
        updateCurrentText(id);
        return;
      }
  
      const target = idToLi.get(id);
      if (target) target.classList.add(currentClass);
      updateCurrentText(id);
    };
  
    const setCurrentBeforeFirstHeading = () => {
      if (!mql?.matches || !firstId) return false;
  
      const firstHeading = document.getElementById(firstId);
      if (!firstHeading) return false;
  
      const triggerY = Math.abs(rootMarginTop) + 1;
      const firstTop = firstHeading.getBoundingClientRect().top;
  
      if (firstTop > triggerY) {
        setCurrentById(mobileHeadingId);
        return true;
      }
  
      return false;
    };
  
    const getHeaderOffset = () => {
      const header =
        document.querySelector(".js-header") ||
        document.querySelector(".l-header") ||
        document.querySelector("header");
  
      return header ? header.offsetHeight : 0;
    };
  
    const scrollToHeading = (target) => {
      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        getHeaderOffset() -
        mobileScrollOffset;
  
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    };
  
    const closeMobileTocAndScroll = (target) => {
      const mobileWrapper = tocRoot?.querySelector(mobileWrapperSelector);
      const listWrapper = tocRoot?.querySelector(mobileListWrapperSelector);
  
      if (!mobileWrapper || !listWrapper || !mql?.matches) {
        scrollToHeading(target);
        return;
      }
  
      const dataStack = mobileWrapper._x_dataStack;
      const state = dataStack?.[0];
  
      if (!state || !(mobileToggleStateKey in state)) {
        scrollToHeading(target);
        return;
      }
  
      if (!state[mobileToggleStateKey]) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToHeading(target);
          });
        });
        return;
      }
  
      let done = false;
  
      const finish = () => {
        if (done) return;
        done = true;
        listWrapper.removeEventListener("transitionend", onEnd);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToHeading(target);
          });
        });
      };
  
      const onEnd = (e) => {
        if (e.target !== listWrapper) return;
        finish();
      };
  
      listWrapper.addEventListener("transitionend", onEnd);
      state[mobileToggleStateKey] = false;
  
      setTimeout(finish, collapseFallbackDelay);
    };
  
    updateMobileHeadingItem();
  
    if (setFirstCurrent && firstId) {
      if (!setCurrentBeforeFirstHeading()) {
        setCurrentById(firstId);
      }
    }
  
    toc.addEventListener("click", (e) => {
      const a = e.target.closest("a");
      if (!a) return;
  
      const id = a.getAttribute("href")?.replace(/^#/, "");
      if (!id) return;
  
      const target = document.getElementById(id);
      if (!target) return;
  
      e.preventDefault();
  
      if (mql?.matches) {
        closeMobileTocAndScroll(target);
      } else {
        scrollToHeading(target);
      }
    });
  
    if (mql) {
      const onChange = () => {
        updateMobileHeadingItem();
  
        if (setCurrentBeforeFirstHeading()) return;
  
        const currentLi = toc.querySelector(`.${currentClass} a`);
        const id = currentLi?.getAttribute("href")?.replace(/^#/, "");
        if (id) updateCurrentText(id);
        else if (firstId) updateCurrentText(firstId);
      };
  
      if (mql.addEventListener) mql.addEventListener("change", onChange);
      else if (mql.addListener) mql.addListener(onChange);
    }
  
    let observer = null;
    if (observeScroll && "IntersectionObserver" in window) {
      const visible = new Set();
  
      const pickCurrent = () => {
        if (setCurrentBeforeFirstHeading()) return;
  
        if (!visible.size) {
          const y = window.scrollY + Math.abs(rootMarginTop) + 1;
          let current = firstId;
          for (const h of headings) {
            if (!h.id) continue;
            if (h.offsetTop <= y) current = h.id;
          }
          if (current) setCurrentById(current);
          return;
        }
  
        let topMost = null;
        let top = Infinity;
        visible.forEach((id) => {
          const el = document.getElementById(id);
          if (!el) return;
          const r = el.getBoundingClientRect();
          if (r.top < top) {
            top = r.top;
            topMost = id;
          }
        });
        if (topMost) setCurrentById(topMost);
      };
  
      observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const id = entry.target.id;
            if (!id) continue;
            if (entry.isIntersecting) visible.add(id);
            else visible.delete(id);
          }
          pickCurrent();
        },
        {
          root: null,
          rootMargin: `${rootMarginTop}px 0px ${rootMarginBottom}px 0px`,
          threshold,
        },
      );
  
      headings.forEach((h) => {
        if (h.id) observer.observe(h);
      });
  
      setTimeout(() => {
        updateMobileHeadingItem();
  
        const hash = location.hash.replace("#", "");
        if (hash && idToLi.has(hash)) {
          setCurrentById(hash);
        } else if (setFirstCurrent && firstId) {
          if (!setCurrentBeforeFirstHeading()) {
            setCurrentById(firstId);
          }
        }
      }, 0);
    }
  
    return {
      toc,
      headings,
      destroy: () => {
        if (observer) observer.disconnect();
      },
    };
  }
  
    var t = [],
    YubinBango;
  !(function (YubinBango) {
    var n = (function () {
      function n(t, n) {
        if (
          (void 0 === t && (t = ""),
          (this.URL = "https://yubinbango.github.io/yubinbango-data/data"),
          (this.g = [
            null,
            "北海道",
            "青森県",
            "岩手県",
            "宮城県",
            "秋田県",
            "山形県",
            "福島県",
            "茨城県",
            "栃木県",
            "群馬県",
            "埼玉県",
            "千葉県",
            "東京都",
            "神奈川県",
            "新潟県",
            "富山県",
            "石川県",
            "福井県",
            "山梨県",
            "長野県",
            "岐阜県",
            "静岡県",
            "愛知県",
            "三重県",
            "滋賀県",
            "京都府",
            "大阪府",
            "兵庫県",
            "奈良県",
            "和歌山県",
            "鳥取県",
            "島根県",
            "岡山県",
            "広島県",
            "山口県",
            "徳島県",
            "香川県",
            "愛媛県",
            "高知県",
            "福岡県",
            "佐賀県",
            "長崎県",
            "熊本県",
            "大分県",
            "宮崎県",
            "鹿児島県",
            "沖縄県",
          ]),
          t)
        ) {
          var e = t.replace(/[０-９]/g, function (t) {
              return String.fromCharCode(t.charCodeAt(0) - 65248);
            }),
            r = e.match(/\d/g),
            o = r.join(""),
            i = this.h(o);
          i ? this.i(i, n) : n(this.j());
        }
      }
      return (
        (n.prototype.h = function (t) {
          if (7 === t.length) return t;
        }),
        (n.prototype.j = function (t, n, e, r, o) {
          return (
            void 0 === t && (t = ""),
            void 0 === n && (n = ""),
            void 0 === e && (e = ""),
            void 0 === r && (r = ""),
            void 0 === o && (o = ""),
            { k: t, region: n, l: e, m: r, o: o }
          );
        }),
        (n.prototype.p = function (t) {
          return t && t[0] && t[1]
            ? this.j(t[0], this.g[t[0]], t[1], t[2], t[3])
            : this.j();
        }),
        (n.prototype.q = function (t, n) {
          window.$yubin = function (t) {
            return n(t);
          };
          var e = document.createElement("script");
          (e.setAttribute("type", "text/javascript"),
            e.setAttribute("charset", "UTF-8"),
            e.setAttribute("src", t),
            document.head.appendChild(e));
        }),
        (n.prototype.i = function (n, e) {
          var r = this,
            o = n.substr(0, 3);
          return o in t && n in t[o]
            ? e(this.p(t[o][n]))
            : void this.q(this.URL + "/" + o + ".js", function (i) {
                return ((t[o] = i), e(r.p(i[n])));
              });
        }),
        n
      );
    })();
    YubinBango.Core = n;
  })(YubinBango || (YubinBango = {}));
  var n = ["Japan", "JP", "JPN", "JAPAN"],
    e = [
      "p-region-id",
      "p-region",
      "p-locality",
      "p-street-address",
      "p-extended-address",
    ],
    YubinBango;
  (!(function (YubinBango) {
    var t = (function () {
      function t() {
        this.s();
      }
      return (
        (t.prototype.s = function () {
          var n = this,
            e = document.querySelectorAll(".h-adr");
          [].map.call(e, function (e) {
            if (n.t(e)) {
              var r = e.querySelectorAll(".p-postal-code");
              r[r.length - 1].addEventListener(
                "keyup",
                function (e) {
                  t.prototype.u(n.v(e.target.parentNode));
                },
                !1,
              );
            }
          });
        }),
        (t.prototype.v = function (t) {
          return "FORM" === t.tagName || t.classList.contains("h-adr")
            ? t
            : this.v(t.parentNode);
        }),
        (t.prototype.t = function (t) {
          var e = t.querySelector(".p-country-name"),
            r = [e.innerHTML, e.value];
          return r.some(function (t) {
            return n.indexOf(t) >= 0;
          });
        }),
        (t.prototype.u = function (t) {
          var n = this,
            e = t.querySelectorAll(".p-postal-code");
          new YubinBango.Core(this.A(e), function (e) {
            return n.B(t, e);
          });
        }),
        (t.prototype.A = function (t) {
          return [].map
            .call(t, function (t) {
              return t.value;
            })
            .reduce(function (t, n) {
              return t + n;
            });
        }),
        (t.prototype.B = function (t, n) {
          var r = [this.C, this.D];
          r.map(function (r) {
            return e.map(function (e) {
              return r(e, t, n);
            });
          });
        }),
        (t.prototype.C = function (t, n, e) {
          if (e) {
            var r = n.querySelectorAll("." + t);
            [].map.call(r, function (t) {
              return (t.value = "");
            });
          }
        }),
        (t.prototype.D = function (t, n, e) {
          var r = {
              "p-region-id": e.k,
              "p-region": e.region,
              "p-locality": e.l,
              "p-street-address": e.m,
              "p-extended-address": e.o,
            },
            o = n.querySelectorAll("." + t);
          [].map.call(o, function (n) {
            return (n.value += r[t] ? r[t] : "");
          });
        }),
        t
      );
    })();
    YubinBango.MicroformatDom = t;
  })(YubinBango || (YubinBango = {})),
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        new YubinBango.MicroformatDom();
      },
      !1,
    ));
  //# sourceMappingURL=./yubinbango.js.map
  

  (() => {
    new ImgParallax("js-parallax");
    new InviewEvent("js-inview");
    new FormConvert("js-convert");
  })();

  // DOMContentLoaded 相当（jQuery ready）
  $(() => {
    // カウントupjs
    new CountUpNumber(".js-countup");
    // クリアボタン
    const clearButtonEl = document.querySelector(".js-clear");
    clearButtonEl && clearFormButton(clearButtonEl);
    // marqueeの実行
    const marqueeEls = document.querySelectorAll(".js-marquee");
    marqueeEls.length &&
      marquee(marqueeEls, ".js-marquee__inner", ".js-marquee__item", {
        pxPerSec: 40,
        tripleAfterFill: true,
      });
    // スマホフッターナビ
    const mobileNavEl = document.querySelector(".js-mobile-nav");
    mobileNavEl && mobileNav(mobileNavEl);
    // パンくずスクロール
    const breadScrollEl = document.querySelector(".js-scroll-breadcrumb");
    breadScrollEl && breadcrumbScrollToggle();
    // メンバースライダー
    const memberSwiperEls = document.querySelectorAll(".js-member-swiper");
    memberSwiperEls.length && memberSwiper(memberSwiperEls);
    // TOPページinfo
    headerInfoSwiper(document);
    // scrollHint
    const scrollHintEl = document.querySelector(".js-scroll-hint");
    scrollHintEl && scrollHint(scrollHintEl);
    // Interviewのスワイパー
    new InterviewSwiper();
    // slideSwiper
    const slideListEls = document.querySelectorAll(".js-list-swiper-wrapper");
    slideListEls.length && slideList(slideListEls);
    // TOPページのjs実行
    const topRoot = document.querySelector(".js-top");
    topRoot && new Top(topRoot);
    // TOC作成
    const tocEl = document.querySelector(".js-toc");
    if (tocEl) {
      createToc({
        tocSelector: ".js-toc",
        contentSelector: ".js-toc-content",
        headingSelector: ".js-toc-heading",
        textSelector: ".js-toc-text",
        idPrefix: "toc",
        setFirstCurrent: true,
        rootMarginTop: -remToPx(8), // 8rem
        rootMarginBottom: -remToPx(6), // 6rem
      });
    }
    // Businessページのjs実行
    const businessRoot = document.querySelector(".js-business");
    businessRoot && new Business(businessRoot);
    // Internshipページのjs実行
    const internshipRoot = document.querySelector(".js-internship");
    internshipRoot && new Internship(internshipRoot);
    // Traningページのjs実行
    const trainingRoot = document.querySelector(".js-training");
    trainingRoot && new Training(trainingRoot);
  });

  // ローディングのフォールバック（最大8秒で閉じる）
  const fallbackTimer = setTimeout(() => {
    const loadingEl = document.querySelector(".js-loading");
    loading(loadingEl);
  }, 8000);

  $(window).on("load", () => {
    moveToHashAfterLoading();
    // ローディング
    clearTimeout(fallbackTimer);
    const loadingEl = document.querySelector(".js-loading");
    loadingEl &&
      setTimeout(() => {
        loading(loadingEl);
      }, 700);
    $(window).trigger("loading");
  });

  $(window).on("loading", () => {
    if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  });
})(jQuery);
